module.exports = __webpack_public_path__ + "static/logo-transparent-bestvpn-1504258566215@2x-ca1fcb4c4c698b6e250310f89c2c7dd5.jpg";